/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsProductListItem,
    IdentityMelcoModelsProductListItemFromJSON,
    IdentityMelcoModelsProductListItemFromJSONTyped,
    IdentityMelcoModelsProductListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsProductListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsProductListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsProductListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductListItem
     */
    list: Array<IdentityMelcoModelsProductListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsProductListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsProductListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsProductListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsProductListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsProductListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsProductListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


